import { render } from "./NotificationSprintHeader.vue?vue&type=template&id=51270e84&ts=true"
import script from "./NotificationSprintHeader.vue?vue&type=script&lang=ts"
export * from "./NotificationSprintHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__